import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import { Link } from 'react-router-dom';
import ToolTip from '../../../components/ToolTipIcon/ToolTip';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';

function RolesActions(props) {
  const { selectedItemsLength, onClickDelete } = props;

  return (
    <div
      data-test="roles-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      <ToolTip toolText="Add Roles">
        <Link
          to="/roles/new"
          data-test="icon-AddRole"
          type="button"
          className="w-[50px] relative cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/upload_icon.svg"
            alt="upload icon"
            className="w-[50px] h-[50px] cursor-pointer"
            draggable={false}
          />
        </Link>
      </ToolTip>

      {selectedItemsLength > 0 && (
        <ToolTipIcon toolText={pluralize('Delete Role', selectedItemsLength)}>
          <button
            type="button"
            onClick={onClickDelete}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/delete_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
    </div>
  );
}

RolesActions.propTypes = {
  selectedItemsLength: PropTypes.number,
  onClickDelete: PropTypes.func,
};

export default RolesActions;
